/*
 *   Persistance Service JavaScript library
 *  (c) 2020 Trinnov Audio
 *
 */
import Long from "long";

const REGEX_ARRAY_ENDING_PATH = /(\[\d+\])$/;
const REGEX_PROPERTY_ENDING_PATH = /(\w+)$/;

export const debugLevelFlag = {
  NORMAL: 0,
  DEBUG: 1,
  TRACE: 2
}

export const subTypeFlag = {
  SUB: 0,
  LIVE: 1,
  TRIGGER: 2,
}

export default class PersistanceService
{

  /*
  * Utils
  */
  static debug_level = debugLevelFlag.NORMAL;
  static t = null;

  static log()
  {
    switch (arguments[0])
    {
      case "FATAL":
      case "CRITICAL":
      case "ERROR": console.error(...arguments); break;
      case "WARNING": console.warn(...arguments); break;
      case "NOTICE":
      case "INFO": console.info(...arguments); break;
      case "DEBUG":
        if (PersistanceService.debug_level > 0)
          console.log(...arguments);
        break;
      case "TRACE":
        if (PersistanceService.debug_level > 1)
          console.log(...arguments);
        break;
      default:
        console.log(...arguments);
    }
  }

  static DeepCompareObjects(x, y, simpleMode)
  {
    var p;
    var leftChain = [];
    var rightChain = [];
    // remember that NaN === NaN returns false
    // and isNaN(undefined) returns true
    if (isNaN(x) && isNaN(y) && typeof x === 'number' && typeof y === 'number')
      return true;

    // Compare primitives and functions.     
    // Check if both arguments link to the same object.
    // Especially useful on the step where we compare prototypes
    if (x === y)
      return true;

   
    // Works in case when functions are created in constructor.
    // Comparing dates is a common scenario. Another built-ins?
    // We can even handle functions passed across iframes
    if ((typeof x === 'function' && typeof y === 'function') ||
      (x instanceof Date && y instanceof Date) ||
      (x instanceof RegExp && y instanceof RegExp) ||
      (x instanceof String && y instanceof String) ||
      (x instanceof Number && y instanceof Number))
      return x.toString() === y.toString();

    // At last checking prototypes as good as we can
    if (!(x instanceof Object && y instanceof Object))
      return false;
    
    if (!simpleMode)
    {
      if (Object.prototype.isPrototypeOf.call(x, 'p') || Object.prototype.isPrototypeOf.call(y, 'x'))
        return false;

      if (x.constructor !== y.constructor)
        return false;

      if (x.prototype !== y.prototype)
        return false;
    }

    // Check for infinitive linking loops
    if (leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1)
      return false;
    
    for (p in y)
    {
      if (simpleMode && typeof y[p] === 'function')
        continue;

      if (Object.prototype.hasOwnProperty.call(y, 'p') !== Object.prototype.hasOwnProperty.call(x, 'p'))
        return false;
      else if (typeof y[p] !== typeof x[p])
        return false;
    }

    for (p in x)
    {
      if (simpleMode && typeof x[p] === 'function')
        continue;

      if (Object.prototype.hasOwnProperty.call(y, 'p') !== Object.prototype.hasOwnProperty.call(x, 'p'))
        return false;
      else if (typeof y[p] !== typeof x[p])
        return false;

      switch (typeof (x[p]))
      {
        case 'object':
        case 'function':

          leftChain.push(x);
          rightChain.push(y);

          if (!PersistanceService.DeepCompareObjects(x[p], y[p], simpleMode))
            return false;
        
          leftChain.pop();
          rightChain.pop();
          break;

        default:
          if (x[p] !== y[p])
            return false;
          break;
      }
    }
    return true;
  }

  static GetProtocol()
  {
    let protocol = window.location.protocol;
    if ((typeof protocol === 'string') && (protocol === 'https:'))
      return 'wss:';
    return 'ws:';
  }

  static S4()
  {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }

  static GenerateUid(persistanceFormat)
  {
    let ret = (PersistanceService.S4()
      + PersistanceService.S4() + "-"
      + PersistanceService.S4() + "-4"
      + PersistanceService.S4().substr(0, 3) + "-"
      + PersistanceService.S4() + "-"
      + PersistanceService.S4() + PersistanceService.S4()
      + PersistanceService.S4()).toLowerCase();

    if (persistanceFormat)
      ret = "UID('" + ret + "')";

    return ret;
  }

  static GetLocalHostName()
  {
    let excludedPath = [
      '/mobile',
      '/fav',
      '/remote',
      /\/[\w]+\.htm[l]*$/gi // index.html & co
    ];

    var pathname = window.location.pathname;

    // le pathname n'existe pas
    if (typeof pathname !== 'string' || pathname[0] !== '/')
      return '/';

    // le pathname est un path exclu
    for (var i = 0; i < excludedPath.length; i++)
    {
      pathname = pathname.replace(excludedPath[i], '');
    }

    // le pathname doit finir par '/'
    if (pathname[pathname.length - 1] !== '/')
      pathname += '/';

    return pathname;
  }

  static Int64ToLong(str)
  {
    if (typeof str == 'number')
      return Long.fromNumber(str);
    if (typeof str != 'string')
      PersistanceService.log("ERROR", "Unknown conversion to Long from : " + typeof str);

    if ((str.substring(0, 7) == "INT64('") && (str.substring(str.length - 2) == "')"))
      return Long.fromString(str.substring(7, str.length - 2), 10);

    PersistanceService.log("ERROR", "Unrecognized long INT64 : " + str);
  }

  static LongToInt64(long)
  {
    let res = long.toString();
    if (!Long.isLong(long))
      PersistanceService.log("WARNING", "number :" + long + " is not a long");
    return "INT64('" + res + "')'";
  }

  // Private Static
  static _Memcpy(dest, destOffset, src, srcOffset, len)
  {
    var dest8 = new Uint8Array(dest, destOffset, len);
    var src8 = new Uint8Array(src, srcOffset, len);
    dest8.set(src8);
  }

  static _ArrayBuffer2String(uint8buf)
  {
    // Pour une raison inconnue, sur qtbrowser (pas avec chromium),
    // String.fromCharCode.apply() génère une exception "Maximum call stack
    // size exceeded" dès que son argument dépasse 65536 caractères. Donc on
    // convertit en string par "petits" bouts de 64k et on concatène...
    var sz = uint8buf.byteLength;
    var pos = 0;
    var sz_max = 65536;
    var str = "";
    while (sz > 0)
    {
      var n = sz;
      if (n > sz_max)
        n = sz_max;
      var x = String.fromCharCode.apply(null, uint8buf.subarray(pos, pos + n));
      str += x;
      sz -= n;
      pos += n;
    }
    return str;
  }

  static _String2ArrayBuffer(str)
  {
    var buf = new ArrayBuffer(str.length);
    var bufView = new Uint8Array(buf);
    for (let i = 0; i < str.length; i++)
      bufView[i] = str.charCodeAt(i);
    return bufView;
  }

  static _PathToProperties(path)
  {
    var msgPath_w = path.replace(/\]/g, ''); // remove the ending ] of arrays
    var path_elements = msgPath_w.split('/');
    
    // recreate the data path, if needed
    for (let i=0; i<path_elements.length; i++)
    {
      if (path_elements[i].length === 0)
      {
        path_elements.splice(i, 1);
        continue;
      }
      // check if any array is included
      for (let p=0; p<path_elements[i].length; p++)
      {
        if (path_elements[i].charAt(p) === '[')
        {
          // break current item
          var target_array_index_str = path_elements[i].substr(p+1);
          var target_array_index = parseInt(target_array_index_str);
          if (!isNaN(target_array_index))
          {
            path_elements[i] = path_elements[i].substr(0, p);
            path_elements.splice(i+1, 0, target_array_index);
          }
        }
      }
    }
    return path_elements;
  }

  static _GetByPath(data, path)
  {
    if (!data || !path)
      return null;

    var current = data;    
    var path_elements = PersistanceService._PathToProperties(path);
    
    for (let i=0; i<path_elements.length; i++)
    {
      if (current[path_elements[i]] === undefined)
      { 
        if (typeof path_elements[i] === 'number')
          current[path_elements[i]] = new Array();
        else
          current[path_elements[i]] = new Object();
      }
      
      current = current[path_elements[i]];
    }

    if (Array.isArray(current))
      return Array.from(current);
    else if (typeof current === "object")
      return Object.assign({}, current);
    else
      return current;
  }

  static _SetByPath(data, path, newData)
  {
    if (!path)
      return;

    var current = data;
    var path_elements = PersistanceService._PathToProperties(path);

    for (let i=0; i<path_elements.length; i++)
    {
      if (i == path_elements.length-1)
        current[path_elements[i]] = newData;
      else
      {
        if (current[path_elements[i]] === undefined)
        { 
          if (typeof path_elements[i] === 'number')
            current[path_elements[i]] = new Array();
          else
            current[path_elements[i]] = new Object();
        }
        current = current[path_elements[i]];
      }
    }
  }

  static _Merge(left, right)
  {
    if (typeof right !== "object")
      left = right;
    else if(Array.isArray(right))
      left = Array.from(right);
    else
    {
      if ((typeof left !== "object") || (left === null) || (Object.keys(left).length <= 0))
        left = right;
      else
      {      
        Object.keys(right).map(function(key)
        {
          if (typeof right[key] === 'undefined')
            delete left[key];
          else if ((typeof right[key] === 'object') && (right[key] != null))
            left[key] = PersistanceService._Merge(left[key], right[key]);
        });
      }
    }
    return left;
  }

  static _SendDataToComponent(jsonData, subEl, callbackComponent)
  {
    if (typeof callbackComponent !== "function")
      return;
    
    var data = jsonData;
    if (Array.isArray(jsonData))
    {
      if (subEl.countList)
        data = jsonData.length;
      else if (subEl.index >= 0)
        data = subEl.index < jsonData.length ? jsonData[subEl.index] : null;
    }

    if (typeof subEl.property === "string")
    {
      callbackComponent({
        property: subEl.property,
        value: data
      });
    }

    if (typeof subEl.callback === "function")
    {
      PersistanceService.log("TRACE", "subEl.callback(data)");
      subEl.callback(data);
    }
  }

  /*
  * Constructor
  */
  constructor(host)
  {
    this.host = host ? host : window.location.host;
    this.websocket = null;
    this.registered_sub = [];
    this.componentRegister = {};
    this.need_to_subscribe_on_init = true;
    this.data = {};
    this.formatters = {};
    this.onGetCb = {};
    this.rpcFifoSub = [];
    this.rpcDataReq = [];
    this.onInitialized = null;
    this.onWaitingConnection = null;

    this.MessagesTypes =
      {
        WMH_GET: 0,
        WMH_SUB: 1,
        WMH_UNSUB: 2,
        WMH_PUBREQ: 3,
        WMH_PUB: 4,
        WMH_RPC: 5,
        WMH_SUB_TRIGGER: 6,
        WMH_UNSUB_TRIGGER: 7,
        WMH_TRIGGER: 8,
        WMH_SUB_LIVE: 9,
        WMH_UNSUB_LIVE: 10,
        WMH_PUBLIVE: 11
      };
    this.ReturnSub = 
    {
       NEW_SUB : 0,
       ALREADY_SUB :1,
       INVALID_SUB :2
    }
  }

  /*
  * Private methode
  */
  Init(onInitialized, onWaitingConnection)
  {
    
    if (!window.WebSocket)
      throw new Error("This browser does not support WebSockets.");

    var PersistanceObject = this;

    PersistanceObject.need_to_subscribe_on_init = true;
    PersistanceObject.reconnect_timeout = null;
    PersistanceObject.websocket = new WebSocket(PersistanceService.GetProtocol() + '//' + PersistanceObject.host + PersistanceService.GetLocalHostName() + 'ws');
    PersistanceObject.websocket.binaryType = 'arraybuffer';
    PersistanceObject.websocket.inputBuffer = null;
    PersistanceObject.websocket.inputBufferFilled = 0;
    PersistanceObject.websocket.upcomingBuffer = null;

    if (typeof onInitialized === "function")
      PersistanceObject.onInitialized = onInitialized;

    if (typeof onWaitingConnection === "function")
      PersistanceObject.onWaitingConnection = onWaitingConnection;

    PersistanceObject.websocket.onopen = function ()
    {
      if (PersistanceObject.need_to_subscribe_on_init)
      {
        var messageType = null;
        PersistanceObject.need_to_subscribe_on_init = false;
  
        for (let i = 0; i < PersistanceObject.registered_sub.length; i++)
        {
          if (PersistanceObject.registered_sub[i].subType === subTypeFlag.SUB)
            messageType = PersistanceObject.MessagesTypes.WMH_SUB;
          else if (PersistanceObject.registered_sub[i].subType === subTypeFlag.LIVE)
            messageType = PersistanceObject.MessagesTypes.WMH_SUB_LIVE;
          else if (PersistanceObject.registered_sub[i].subType === subTypeFlag.TRIGGER)
            messageType = PersistanceObject.MessagesTypes.WMH_SUB_TRIGGER;
          else
            messageType = null;

          if (messageType !== null)
            PersistanceObject.Pack(messageType, PersistanceObject.registered_sub[i].path, null);
        }

      }
      
      PersistanceService.log("INFO", "Websocket Connected");
      
      if (typeof PersistanceObject.onInitialized === "function")
      {
        PersistanceObject.get("/config", function(path, data){
          PersistanceObject.onInitialized(data);
        });
      }
    }
    this.websocket.onmessage = function (evt)
    {
      try
      {
        var remainingBytes = evt.data.byteLength;
        if (this.upcomingBuffer)
        {
          // fill frame size first
          if (this.inputBuffer !== null)
            throw new Error("inputBuffer != null");

          let bytesToCopy = Math.min(remainingBytes, 4 - this.upcomingBuffer.byteLength);
          var FrameSizeBuff = new ArrayBuffer(4);
          PersistanceService._Memcpy(FrameSizeBuff, 0, this.upcomingBuffer, 0, this.upcomingBuffer.byteLength);
          PersistanceService._Memcpy(FrameSizeBuff, this.upcomingBuffer.byteLength, evt.data, 0, bytesToCopy);
          remainingBytes -= bytesToCopy;
          if (bytesToCopy + this.upcomingBuffer.byteLength === 4)
          {
            let dv = new DataView(FrameSizeBuff);
            let dataSize = dv.getInt32(0);
            FrameSizeBuff = null;
            delete this.upcomingBuffer;
            this.upcomingBuffer = null;
            this.inputBuffer = new ArrayBuffer(dataSize);
          }
          else
          {
            delete this.upcomingBuffer;
            this.upcomingBuffer = FrameSizeBuff;
            if (remainingBytes !== 0)
              throw new Error("remainingBytes != 0");
          }
        }
        while (remainingBytes > 0)
        {
          if (this.inputBuffer)
          {
            // end of an already started message
            // copy the incoming data to the end of the buffer
            let bytesToCopy = Math.min(remainingBytes, (this.inputBuffer.byteLength - this.inputBufferFilled));
            if (bytesToCopy > 0)
            {
              PersistanceService._Memcpy(this.inputBuffer, this.inputBufferFilled, evt.data, evt.data.byteLength - remainingBytes, bytesToCopy);
              this.inputBufferFilled += bytesToCopy;
              remainingBytes -= bytesToCopy;
            }
          }
          else if (remainingBytes > 4)
          {
            let dv = new DataView(evt.data);
            let dataSize = dv.getInt32(evt.data.byteLength - remainingBytes);
            remainingBytes -= 4;
            this.inputBuffer = new ArrayBuffer(dataSize);
            let bytesToCopy = Math.min(remainingBytes, dataSize);
            if (bytesToCopy > 0)
            {
              PersistanceService._Memcpy(this.inputBuffer, 0, evt.data, evt.data.byteLength - remainingBytes, bytesToCopy);
              this.inputBufferFilled = bytesToCopy;
              remainingBytes -= bytesToCopy;
            }
          }
          else
          {
            this.upcomingBuffer = new ArrayBuffer(remainingBytes);
            PersistanceService._Memcpy(this.upcomingBuffer, 0, evt.data, evt.data.byteLength - remainingBytes, remainingBytes);
            return;
          }
          if (this.inputBufferFilled === this.inputBuffer.byteLength)
          {
            try
            {
              PersistanceObject.UnPack(this.inputBuffer);
            }
            catch (e)
            {
              PersistanceService.log("ERROR", e.stack);
            }
            /*mirror unpack, au cas ou return prématuré de celui-ci*/
            this.inputBufferFilled = 0;
            delete this.inputBuffer;
            this.inputBuffer = null;
          }
        }
      }
      catch (e)
      {
        PersistanceService.log("ERROR", e.message);
      }
    }
    this.websocket.onclose = function (evt)
    {

      PersistanceService.log("INFO", "WebSocket Closed - event code: " + evt.code);
      PersistanceService.log("INFO", "WebSocket Closed - event reason: " + evt.reason);
      // Cf. http://tools.ietf.org/html/rfc6455#section-11.7
      if (!evt.wasClean || evt.code > 1001)
      {
        if (typeof PersistanceObject.onWaitingConnection === "function")
          PersistanceObject.onWaitingConnection();
          
        PersistanceObject.Reset();
      }
    }
    this.websocket.onerror = function (evt)
    {
      PersistanceService.log("ERROR", "WebSocket Error - event code: " + evt.code);
      PersistanceService.log("ERROR", "WebSocket Error - event reason: " + evt.reason);
    }
  }

  Close()
  {
    if (this.websocket)
      this.websocket.close();
  }


  Reset()
  {
    this.Close();
    var PersistanceObject = this;

    if (!this.reconnect_timeout)
      this.reconnect_timeout = setTimeout(function () { PersistanceObject.Init(); }, 2000);
  }

  Pack(type, pathstr, jsondata)
  {
    var PathBuf = PersistanceService._String2ArrayBuffer(pathstr);
    var BuffNeededSize = PathBuf.byteLength + 1 /* type*/ + 4 /*path size*/;
    if (jsondata)
    {
      var DataBuf = PersistanceService._String2ArrayBuffer(JSON.stringify(jsondata));
      BuffNeededSize += DataBuf.byteLength;
    }
    var Buffer = new ArrayBuffer(BuffNeededSize + 4);
    var dv = new DataView(Buffer);
    dv.setInt32(0, BuffNeededSize);
    dv.setInt8(4, type);
    dv.setInt32(5, PathBuf.byteLength);
    PersistanceService._Memcpy(Buffer, 9, PathBuf, 0, PathBuf.byteLength);
    if (jsondata)
      PersistanceService._Memcpy(Buffer, 9 + PathBuf.byteLength, DataBuf, 0, DataBuf.byteLength);
    if (this.websocket && this.websocket.readyState === 1)
      this.websocket.send(Buffer);
    else
      PersistanceService.log("ERROR", "failed to send websocket message to " + pathstr);
  }


  UnPack(inputBuffer)
  {
    // check we have received a frame
    var dv = new DataView(inputBuffer);
    var dataType = dv.getInt8(0);
    var dataPathLen = dv.getInt32(1);

    if ((inputBuffer.byteLength - 5) < dataPathLen)
    {
      PersistanceService.log("ERROR", 'path length ' + dataPathLen + ' oversize message buffer size (' + inputBuffer.byteLength + ')');
      return;
    }
    var msgPathBuff = new Uint8Array(inputBuffer, 5, dataPathLen);
    var msgPath = PersistanceService._ArrayBuffer2String(msgPathBuff);
    var msgDataBuff = new Uint8Array(inputBuffer, 5 + dataPathLen);
    var msgData = PersistanceService._ArrayBuffer2String(msgDataBuff);

    if (msgData === null || msgData === undefined || msgData.length <= 0)
    {
      PersistanceService.log("WARNING", "msgData empty for " +msgPath);
      this.websocket.inputBufferFilled = 0;
      delete this.websocket.inputBuffer;
      this.websocket.inputBuffer = null;
      return;
    }

    var JsonData = {};
    try
    {
      JsonData = JSON.parse(msgData);
      if (JsonData._ !== undefined)
        JsonData = JsonData._;
    }
    catch (e)
    {
      PersistanceService.log("ERROR", "while decompressing JSON DATA: ", e.message, msgData);
      // force to reinit the connexion
      this.Reset();
      return;
    }

    this.websocket.inputBufferFilled = 0;
    delete this.websocket.inputBuffer;
    this.websocket.inputBuffer = null;

    if (dataType === this.MessagesTypes.WMH_GET)
    {
      if (Array.isArray(this.onGetCb[msgPath]) && this.onGetCb[msgPath].length > 0)
      {
        for (let elGetCb of this.onGetCb[msgPath])
          elGetCb.cb(msgPath, JsonData, elGetCb.ctx);
      }
      delete this.onGetCb[msgPath];
    }
    else if (dataType === this.MessagesTypes.WMH_RPC)
    {
      if (typeof JsonData["id"] === 'string' && JsonData["id"].replace("UID('", "").replace("')", "") === msgPath)
      {
        if (this.rpcFifoSub.length > 0)
        {
          let rpcSubEl = this.rpcFifoSub.shift();
          rpcSubEl.idService = msgPath;
          this.rpcDataReq.push(rpcSubEl);
        }
      }
      else
      {
        this.rpcDataReq = this.rpcDataReq.filter(el =>
        {
          if (el.idService === msgPath)
          {
            el.success(JsonData);
            el.success = null;
            return false;
          }
          return true;
        });
      }
    }
    else
      this.dispatchEvent(msgPath, JsonData, dataType);
  }

  /*
 * Public API
 */
  getTreeValue(path)
  {
    return PersistanceService._GetByPath(this.data, path);
  }

  // Data retreival
  get(path, ResultCb, Context)
  {
    if (!Array.isArray(this.onGetCb[path]))
      this.onGetCb[path] = [];
    
    this.onGetCb[path].push({ cb: ResultCb, ctx: Context });
 
    this.Pack(this.MessagesTypes.WMH_GET, path, null);
    PersistanceService.log("DEBUG", "Get '" + path + '"');
  }

  // Publication Request
  pubreq(path, data)
  {
    var data_request = {};
    if (typeof data !== "object")
    {
      var propertyPathRegex = REGEX_PROPERTY_ENDING_PATH.exec(path);
      if (propertyPathRegex)
      {
        path = path.substring(0, propertyPathRegex.index);
        data_request[propertyPathRegex[0]] = data;
      }
    }
    else
      data_request = data;

    this.Pack(this.MessagesTypes.WMH_PUBREQ, path, data_request);
    PersistanceService.log("TRACE", "Pubreq to " + path, data_request);
  }

  // Publication RPC Request
  pubreq_rpc(path, data, onSuccess, onError)
  {
    if (!onSuccess || typeof onSuccess !== 'function')
      return;

    this.rpcFifoSub.push({
      idService: null,
      success: onSuccess,
      error: onError
    });

    this.Pack(this.MessagesTypes.WMH_RPC, path, data);

    PersistanceService.log("TRACE", "PubReqRpc to " + path);
  }

  // Node path Sub & Unsub
  subscribe(path, subType)
  {
    let messageType = null;

    if (subType === subTypeFlag.SUB)
      messageType = this.MessagesTypes.WMH_SUB;
    else if (subType === subTypeFlag.LIVE)
      messageType = this.MessagesTypes.WMH_SUB_LIVE;
    else if (subType === subTypeFlag.TRIGGER)
      messageType = this.MessagesTypes.WMH_SUB_TRIGGER;
    else
      return this.ReturnSub.INVALID_SUB;

    for (let i = 0; i < this.registered_sub.length; i++)
    {
      if (this.registered_sub[i].path === path)
      {
        this.registered_sub[i].refcount++;
        return this.ReturnSub.ALREADY_SUB;
      }
    }

    this.registered_sub.push({ path: path, subType: subType, refcount: 1 });

    if (this.websocket.readyState !== 1)
    {
      this.need_to_subscribe_on_init = true;
      return this.ReturnSub.NEW_SUB;
    }

    this.Pack(messageType, path, null);
    PersistanceService.log("DEBUG","Subscribed(type="+ subType +") to " + path);
    return this.ReturnSub.NEW_SUB;
  }

  unsubscribe(path, subType)
  {
    let messageType = null;
    if (subType === subTypeFlag.SUB)
      messageType = this.MessagesTypes.WMH_UNSUB;
    else if (subType === subTypeFlag.LIVE)
      messageType = this.MessagesTypes.WMH_UNSUB_LIVE;
    else if (subType === subTypeFlag.TRIGGER)
      messageType = this.MessagesTypes.WMH_UNSUB_TRIGGER;
    else
      return;

    for (let i = 0; i < this.registered_sub.length; i++)
    {
      if (this.registered_sub[i].path === path && this.registered_sub[i].subType === subType)
      {
        this.registered_sub[i].refcount--;
        if (this.registered_sub[i].refcount > 0)
          return;

        this.registered_sub.splice(i, 1);
        PersistanceService.log("DEBUG", "Unsubscribed(type="+ subType +") to " + path);
        break;
      }
    }

    this.Pack(messageType, path, null);
    PersistanceService.log("DEBUG","No more subscribe(type="+ subType +") to " + path);
  }

  ComponentSubscribe(option)
  {
    if (!option.uid
      || !option.subs
      || option.subs.length <= 0
      || typeof option.callback != "function")
      return false;
    
    let sendAlreadySub = [];
    let subs = [];

    for (let i = 0; i < option.subs.length; i++)
    {
      if (typeof option.subs[i].path !== "string")
        continue;

      if (typeof option.subs[i].property !== "string" && typeof option.subs[i].callback !== "function")
        continue;
            
      let subEl = 
      {
        index : -1,
        path : option.subs[i].path,
        property:  option.subs[i].property,
        callback :  option.subs[i].callback,
        subType: option.subs[i].subType ? option.subs[i].subType : subTypeFlag.SUB,
        countList: option.subs[i].countList ? option.subs[i].countList : false,
        autoPubreq : option.subs[i].autoPubreq ? option.subs[i].autoPubreq : false,
        optimistic : option.subs[i].optimistic ? option.subs[i].optimistic : false,
        firstInitProperty : true,
        filtersProperty : Array.isArray(option.subs[i].filtersProperty) ? option.subs[i].filtersProperty : null,
      }

      let arrayPathRegex = REGEX_ARRAY_ENDING_PATH.exec(option.subs[i].path);
      if (arrayPathRegex)
      {
        let tmp = parseInt(arrayPathRegex[0].replace("[", "").replace("]", ""));
        if (!isNaN(tmp))
        {
          subEl.index = tmp;
          subEl.path = option.subs[i].path.substring(0, arrayPathRegex.index);
        }
      }

      subs.push(subEl);

      if (this.subscribe(subEl.path, subEl.subType) === this.ReturnSub.ALREADY_SUB)
      {
        let jsonData = this.getTreeValue(subEl.path);
        if (typeof jsonData !== "object" || Object.keys(jsonData).length > 0)
          sendAlreadySub.push({
            jsonData : jsonData,
            subEl : subEl,
            callbackComponent : option.callback,
          });
      }
    }

    this.componentRegister[option.uid] = {
      subs: subs,
      callback: option.callback
    };

    for (let i = 0; i < sendAlreadySub.length; i++)
      PersistanceService._SendDataToComponent(sendAlreadySub[i].jsonData, sendAlreadySub[i].subEl, sendAlreadySub[i].callbackComponent);
  
    PersistanceService.log("DEBUG", "componentRegister =", this.componentRegister);
    return true;
  }

  GetComponentConfig(uid)
  {
    if (Object.keys(this.componentRegister).length <= 0) 
      return null;

    if (uid)
      return this.componentRegister[uid];
    else
      return this.componentRegister;
  }

  SetComponentConfigProperty(uid, property, optionName, optionValue)
  {
    if (typeof property !== "string" || typeof optionName !== "string")
      return;

    if (Object.keys(this.componentRegister).length <= 0
    ||  !Array.isArray(this.componentRegister[uid].subs))
      return;

    for (let i = 0; i < this.componentRegister[uid].subs.length; i++)
    {
      if (this.componentRegister[uid].subs[i].property === property)
      {
        this.componentRegister[uid].subs[i][optionName] = optionValue;
        break;
      }
    }
  }

  ComponentUnsubscribe(uid)
  {
    if (Object.keys(this.componentRegister).length <= 0)
      return;
    
    if (Array.isArray(this.componentRegister[uid].subs))
    {
      var subEl = null;
      for (let i = 0; i < this.componentRegister[uid].subs.length; i++)
      {
        subEl = this.componentRegister[uid].subs[i];
        if (typeof subEl.path !== "string")
          continue;
        this.unsubscribe(subEl.path, subEl.subType);
      }
    }
    delete this.componentRegister[uid];
  }

  dispatchEvent(msgPath, jsonData, messageType)
  {
    var subType = null;
    if (messageType === this.MessagesTypes.WMH_PUB)
      subType = subTypeFlag.SUB;
    if (messageType === this.MessagesTypes.WMH_PUBLIVE)
      subType = subTypeFlag.LIVE;
    else if (messageType === this.MessagesTypes.WMH_TRIGGER)
      subType = subTypeFlag.TRIGGER;

    if (subType === null)
    {
      PersistanceService.log("ERROR", "dispatchEvent messageType incorrecte");
      return;
    }

    // to not take in account a null object event : nothing to merge
    // may be a wrong subscription (not handled in this configuration)
    if (typeof jsonData === "undefined")
    {
      PersistanceService.log("WARNING", "dispatchEvent jsonData undefined");
      return;
    }

    // Si c'est un message PUB, on garde un copy dans this.data
    if (messageType === this.MessagesTypes.WMH_PUB)
    { 
      let elPersistance = PersistanceService._GetByPath(this.data, msgPath);
      let mergedData = PersistanceService._Merge(elPersistance, jsonData);
      PersistanceService._SetByPath(this.data, msgPath, mergedData);
    }

    var componentToUnsubIds = [];

    PersistanceService.log("TRACE", "dispatchEvent for " + msgPath);

    for (let i = 0; i < Object.values(this.componentRegister).length; i++)
    {
      var el = Object.values(this.componentRegister)[i];

      if (typeof el.callback !== "function")
      {
        let uid = Object.keys(this.componentRegister)[i]
        componentToUnsubIds.push(uid);
        PersistanceService.log("WARNING", "dispatchEvent : callback for " + uid + " doesn't exist yet");
        continue;
      }
      for (let j = 0; j < el.subs.length; j++)
      {
        if (el.subs[j].path === msgPath && el.subs[j].subType === subType)
          PersistanceService._SendDataToComponent(jsonData, el.subs[j], el.callback);
      }
    }

    for (let i in componentToUnsubIds)
      this.ComponentUnsubscribe(componentToUnsubIds[i]);

    return;
  }

}

